import type { CsvRow, SortCol, SortDir } from '../tools/types';

export function sortRows(rows: CsvRow[], col: SortCol, dir: SortDir): CsvRow[] {
  return [...rows].sort((a, b) => {
    let cmp = 0;

    if (col === 'name') {
      // Primary: name alphabetical
      cmp = (a.name || '').localeCompare(b.name || '');
      // Secondary: date ascending within same name
      if (cmp === 0) {
        const da = a.parsedDate?.getTime() ?? Infinity;
        const db = b.parsedDate?.getTime() ?? Infinity;
        cmp = da - db;
      }
    } else if (col === 'date') {
      // Primary: date chronological
      const da = a.parsedDate?.getTime() ?? Infinity;
      const db = b.parsedDate?.getTime() ?? Infinity;
      cmp = da - db;
      // Secondary: name alphabetical
      if (cmp === 0) {
        cmp = (a.name || '').localeCompare(b.name || '');
      }
    } else  {
      cmp = (a.type || '').localeCompare(b.type || '');
      if (cmp === 0) {
        const da = a.parsedDate?.getTime() ?? Infinity;
        const db = b.parsedDate?.getTime() ?? Infinity;
        cmp = da - db;
      }
    }

    return dir === 'asc' ? cmp : -cmp;
  });
}

export function filterRows(rows: CsvRow[], query: string): CsvRow[] {
  const q = query.trim().toLowerCase();
  if (!q) return rows;
  return rows.filter(r =>
    r.name.toLowerCase().includes(q) ||
    (r.date || '').toLowerCase().includes(q) ||
    (r.type || '').toLowerCase().includes(q) ||
    Object.values(r.extra).some(v => v.toLowerCase().includes(q))
  );
}
